<div class="px-3 py-2">
	<h4 align="center">Cifris Chain 2019</h4>
	<p>Il <b> 9 maggio 2019</b> si è svolto a Roma l'evento CifrisChain 2019, 
		primo incontro tra i partecipanti PQCifris della costituenda 
		Associazione De Componendis Cifris.</p>
	<p>Luogo CONSOB:</p>
	<ul>
		<li>sede di Roma - Via Giovanni Battista Martini, 3;</li>
		<li>sede di Milano (in videoconferenza) - Via Broletto, 7.</li>
	</ul>
	<br>
	<h6><a href="../../../../assets/eventi/2019/RomaCifrisChain/CifrisChain.pdf">LOCANDINA EVENTO</a></h6>
	<p>Questo evento ha offerto una panoramica sulle attività riguardanti gli 
		aspetti crittografici della tecnologia Blockchain e le cryptocurrency, 
		con particolare enfasi alle applicazioni Fintech. È stata inoltre 
		l'occasione per presentare l'iniziativa Cifris Chain.</p>
		<h5>PROGRAMMA</h5>
		<ul>
			<li>
				<p><b>14:30-15:15 Sessione I</b></p>
				<ul class="ulSon">
					<li>
						<p>
							14:30 Dott. Paolo Ciocca <br>
							CONSOB <br>
							<i style="color: green;">Commissario</i>
						</p>
					</li>
					<li>
						<p>
							14:45 Dott. Paolo Schiavo<br>
							Ministero del Tesoro <br>
							<i style="color: green;"> Responsabile sistemi informativi e innovazione </i>
						</p>
					</li>	
					<li>
						<p>
							15:00 Prof. Massimiliano Sala <br>
							De Componendis Cifris <br>
							<i style="color: green;">Acting Director</i><br>
							<a href="../../../../assets/eventi/2019/RomaCifrisChain/MSALA_CifrisChain.pdf">Slide</a>
						</p>
					</li>
				</ul>
			</li>
			<li><p><b>15:15 -15:30  Pausa caffè</b></p></li>
			<li>
				<p><b>15:30-17:10 Sessione II</b></p>
				<ul class="ulSon">
					<li>
						<p>
							15:30 Prof. Ivan Visconti <br>
							Università di Salerno <br>
							<a href="../../../../assets/eventi/2019/RomaCifrisChain/IVISCONTI.pdf">Sicurezza nelle blockchain 
								pubbliche: il problema del consenso</a>
						</p>
					</li>
					<li>
						<p>
							15:50 Dott. Angelo De Caro <br>
							IBM - Zurich Research <br>
							<a href="../../../../assets/eventi/2019/RomaCifrisChain/ANGELODECARO.pdf">Sicurezza nelle 
								blockchain private: "il caso delle offerte pubbliche iniziali (IPO)"</a>
						</p>
					</li>
					<li>
						<p>
							16:10 Prof. Norberto Gavioli <br>
							Università dell'Aquila <br>
							<a href="../../../../assets/eventi/2019/RomaCifrisChain/NGAVIOLI.pdf">Spunti di ricerca in Cifris Chain</a>
						</p>
					</li>
					<li>
						<p>
							16:30 Prof. Andrea Bracciali <br>
							University of Stirling <br>
							<a href="../../../../assets/eventi/2019/RomaCifrisChain/ABRACCIALI.pdf">Sicurezza negli smart contract</a>
						</p>
					</li>
					<li>
						<p>
							16:50 Dott. Luca Cermelli <br>
							Horizen <br>
							<a href="../../../../assets/eventi/2019/RomaCifrisChain/LCERMELLI.pdf">Crittovalute: il caso di Horizen</a>
						</p>
					</li>
				</ul>
			</li>
		</ul>
		<hr>
		<p>Eventuali richieste possono essere inviate a: <a href="cifrischain@decifris.it">pqcifris&#64;decifris.it.</a></p>
		<p>Questo evento è stato pianificato dall'Acting Director della De Componendis 
			Cifris e dal Coordinatore Cifris Chain.</p>
</div>